// extracted by mini-css-extract-plugin
export default {"box":"infocustomer_box__cZ9E1","infoUser":"infocustomer_infoUser__cjIPz","infoUserTel":"infocustomer_infoUserTel__h+WxU","infoEmail":"infocustomer_infoEmail__PFp8h"};